import MD5 from 'md5'

const KEY = '8tJmXzHHfHkrjY7H6J3TtwsYhZpfhtt3'

// 定义排序方法
function sortObjByKey(obj) {
    // 获取原对象集的key值赋给keys
    const keys = Object.keys(obj).sort()
    // 定义一个新的对象newObj，遍历keys并将每个key值添加到newObj，根据key匹配原对象集obj对应的key值
    let newObj = {}
    for (let i = 0; i < keys.length; i++) {
        const index = keys[i]
        newObj[index] = obj[index]
    }
    // 返回一个新的对象newObj（与原对象的区别：值为0或undefined的键值对，值变为空字符串）
    return newObj
}

export function getReqData(data) {
    data.time = parseInt(Date.parse(new Date()) / 1000).toString()
    let subData = sortObjByKey(data)
    let tmpStr = ''
    for (const key in subData) {
      let tmp = ''
      if (key !== 'sign') {
        if (subData[key]) {
          tmp = subData[key]
        } else {
          subData[key] = ''
        }
        tmpStr += key + '=' + tmp + '&'
      }
    }
    tmpStr = KEY + tmpStr.substr(0, tmpStr.length - 1)
    subData.sign = MD5(tmpStr)
    return subData
}

export function getGetParams (data) {
    const keys = Object.keys(data).sort();
    let urlParams = '?';
    for (let i = 0; i < keys.length; i++) {
        const index = keys[i];
        if (i === keys.length) {
            urlParams = urlParams + index + '=' + encodeURIComponent(data[index]);
        } else {
            urlParams = urlParams + index + '=' + encodeURIComponent(data[index]) + '&';
        }
    }
    return urlParams
}

export function UrlSearch() {
  let obj = {}
  let name, value;
  let str = window.location.href; // 取得整个地址栏
  let num = str.indexOf("?") 
  str = str.substr(num+1); // 取得所有参数   stringvar.substr(start [, length ]

  var arr = str.split("&"); // 各个参数放到数组里
  for(var i = 0; i < arr.length; i++){ 
  num = arr[i].indexOf("="); 
  if(num > 0){ 
    name = arr[i].substring(0, num);
    value = arr[i].substr(num + 1);
    obj[name] = value;
    } 
  }
  return obj
}
